var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { PaymentMethod } from '../Model';
import Theme from '../../../Theme';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { toDateTime, toMoney } from '../../../helpers/Format';
import QRCodeSVG from '../../../elements/QRCode';
import cxs from 'cxs/component';
import theme from '../../../Theme';
import Text from '../../../elements/Text';
import { T } from '../../../helpers/i18n';
var VoucherDetail = /** @class */ (function (_super) {
    __extends(VoucherDetail, _super);
    function VoucherDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VoucherDetail.prototype.render = function () {
        var item = this.props.voucher;
        console.log('voucher: ', item);
        // item.image = `${process.env.REACT_APP_SERVER}${item.image}`
        var externalCloseBtn = React.createElement("button", { className: "close", style: { color: Theme.color.primary, position: 'absolute', top: '50px', right: '15px', fontSize: 60 }, onClick: this.props.onToggle }, "\u00D7");
        return (React.createElement("div", { className: "animated fadeIn respond-print-hide" },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Modal, { style: { minWidth: '600px' }, centered: true, fade: true, isOpen: true, modalTransition: { timeout: 700 }, backdropTransition: { timeout: 1000 }, toggle: this.props.onToggle, external: externalCloseBtn },
                        React.createElement(ModalHeader, null, "".concat(item.display_id)),
                        React.createElement(ModalBody, null,
                            React.createElement(RenderVoucher, { item: item })))))));
    };
    return VoucherDetail;
}(Component));
export default VoucherDetail;
export var RenderVoucher = function (_a) {
    var item = _a.item;
    var afiliate = typeof item.affiliate_company === 'string' ? JSON.parse(item.affiliate_company) : item.affiliate_company;
    var agent = typeof item.agent === 'string' ? JSON.parse(item.agent) : item.agent;
    var boxPayments;
    if (item.boxPayments) {
        boxPayments = typeof item.boxPayments === 'string' ? JSON.parse(item.boxPayments || '[]') : item.boxPayments || [];
    }
    else {
        if (item.amount_paid) {
            boxPayments = [{
                    amount: item.amount_paid / 100,
                    method: PaymentMethod.Credit
                }];
        }
    }
    console.log('boxPayments: ', boxPayments);
    return (React.createElement("div", { className: 'container' },
        item.lines.map(function (line) { return (React.createElement("div", { className: "row mt-1 mb-1 border" },
            React.createElement("div", { className: "col mt-3 mb-3" },
                React.createElement("div", { className: "col " },
                    React.createElement("div", { className: "row" },
                        React.createElement(Text, { big: true, style: { marginTop: 0, marginBottom: 0, } }, item.itemName)),
                    React.createElement("div", { className: "row" },
                        React.createElement(Text, { style: { marginTop: 0, marginBottom: 0, fontWeight: 'bold' } },
                            "1 ",
                            line.display_name,
                            " -"),
                        React.createElement(Text, { style: { marginTop: 0, marginBottom: 0, } }, toDateTime(item.start_at))),
                    React.createElement("div", { className: "row" },
                        React.createElement(Text, { small: true, style: { marginTop: 0, marginBottom: 0, fontWeight: 'bold' } }, "Reserva n.\u00BA "),
                        React.createElement(Text, { small: true, style: { marginTop: 0, marginBottom: 0, } }, "".concat(item.pk, " "))),
                    React.createElement("div", { className: "row" },
                        React.createElement(Text, { style: { fontWeight: 'bold' }, small: true },
                            ' Nombre:',
                            " "),
                        React.createElement(Text, { small: true }, item.contactName)))),
            React.createElement("div", { className: "col mt-3 mb-3", style: { textAlign: 'right', verticalAlign: 'center' } },
                React.createElement(QRCodeSVG, { key: line.checkin_url, value: encodeURI(line.checkin_url), size: 100, level: 'H' })))); }),
        React.createElement("div", { className: "row mt-3 mb-3" },
            React.createElement("div", { className: "col mt-1 mb-1" },
                React.createElement(Text, { big: true, style: {
                        backgroundColor: item.receipt_total === item.amount_paid ? 'green' : item.receipt_total > item.amount_paid ? 'red' : item.receipt_total < item.amount_paid ? 'orange' : undefined,
                        color: 'white',
                        height: '30px',
                        paddingLeft: '10px'
                    } }, "".concat(T('total'), " ").concat(toMoney(item.receipt_total / 100))),
                React.createElement(Text, { style: { color: item.amount_paid > 0 ? 'green' : undefined } }, "".concat(T('paid'), " ").concat(toMoney(item.amount_paid / 100))),
                React.createElement(Text, { primary: ((item.receipt_total - item.amount_paid) / 100) > 0 }, "".concat(T('unpaid'), " ").concat(toMoney((item.receipt_total - item.amount_paid) / 100)))),
            React.createElement("div", { className: "col mt-1 mb-1" }, boxPayments && boxPayments.length > 0 && React.createElement("div", null,
                React.createElement(Text, { big: true }, T('payments')),
                boxPayments.map(function (boxPayment) {
                    return React.createElement(RenderAA, { title: T(boxPayment.method), data: toMoney(boxPayment.amount), key: boxPayment.method });
                }))),
            afiliate &&
                React.createElement(RenderAA, { title: "".concat(T('afiliate')), data: afiliate.name }))));
};
var StyledText = cxs('Text')({
    color: theme.color.secondary,
    ':hover': {
        color: Theme.color.primary
    },
});
var RenderAA = function (_a) {
    var data = _a.data, title = _a.title;
    return (React.createElement("div", { className: "col mt-1 mb-1" },
        React.createElement("div", { className: "row" },
            React.createElement(Text, { big: true, style: { marginTop: 0, marginBottom: 0 } }, title)),
        React.createElement("div", { className: "row" },
            React.createElement(Text, { small: true, style: { marginTop: 0, marginBottom: 0 } }, "".concat(data)))));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/VoucherDetail.tsx
// module id = 489
// module chunks = 0